import { HttpParams } from '@angular/common/http';
import { Component, ViewChild, EventEmitter, Output, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Table } from 'primeng/table';
import { BuscadorOperadorService } from './buscadoroperador.service';
import { FilterTNTOperatorViewModel, TcTNTPaisViewModel, TImportadorItemResultsViewModel } from './buscadoroperador.types';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { TImportadorViewModel } from '../../../../../_mantenimiento/general/solicitudes/solicitud.types';
import { Dialog } from 'primeng/dialog/dialog';
import { EnumIdsTcPais, Tc } from '../../../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-buscador-operador-list',
    templateUrl: './buscadoroperador-list.component.html',
})
export class BuscadorOperadorListComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<TImportadorViewModel>();
    @Output() selectedImpLugarDestino = new EventEmitter<TImportadorViewModel>();

    @ViewChild('tableSearch') turboTable: Table;

    resultOperadores: TImportadorItemResultsViewModel;
    cols: any[];
    listTipoOperador: Tc[] = [
        { Id: 1, Descripcion: 'EURPO' },
        { Id: 2, Descripcion: 'EUPO' },
    ];
    selectedValue: string;

    selectedTImportador: TImportadorViewModel | null;

    display = false;

    listPais: TcTNTPaisViewModel[];

    visibilitySpinner = false;

    public isCollapsed = false;
    isImpLugarDestino = false;

    constructor(
        private fb: UntypedFormBuilder,
        private notificacionService: NotificationService,
        private buscadorOperadorService: BuscadorOperadorService,
    ) {
        super();

        this.resultOperadores = new TImportadorItemResultsViewModel();
    }

    ngOnInit() {
        this.selectedValue = 'EURPO';

        this.cols = [
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Localidad', header: 'Localidad' },
            { field: 'CodigoPostalImportador', header: 'Código Postal' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'RefTraces', header: 'Referencia' },
            { field: 'TipoRefTraces', header: 'Tipo Referencia' },
            { field: 'TipoOperador', header: 'Tipo Operador' },
        ];

        //Como hasta ahora.
        this.form = this.fb.group({
            IdPais: [null, Validators.required],
            Nombre: '',
            TipoOperador: '',
        });

        this.isCollapsed = false;

        //this.loadBack();
    }

    onSearchButton(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('idPais', this.form.value.IdPais);
        params = params.append('nombre', this.form.value.Nombre);
        params = params.append('TipoOperador', this.form.value.TipoOperador);

        this.loading = true;
        this.buscadorOperadorService.getTNTOperatorsByFilter(params).subscribe(result => {
            this.selectedTImportador = null;
            this.resultOperadores = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            IdPais: null,
            Nombre: '',
            TipoOperador: 'EURPO',
        });
        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultOperadores = new TImportadorItemResultsViewModel();
    }

    CreateModel(): FilterTNTOperatorViewModel {
        let model: FilterTNTOperatorViewModel = new FilterTNTOperatorViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    showDialog(esLugarDestino: boolean, idPais: number | null, isTransito: boolean, isTraslado: boolean, idPaisTraslado: number | null): void {
        this.onCleanButton();

        this.display = true;
        this.selectedTImportador = null;
        this.isImpLugarDestino = esLugarDestino;

        if (this.includeEspania(isTransito, isTraslado, idPaisTraslado, this.isImpLugarDestino)) {
            this.buscadorOperadorService.getPaisesOperatorsAllUE().subscribe(res => {
                this.listPais = res;

                if (idPais) {
                    this.form.patchValue({
                        IdPais: this.listPais.find(x => x.Id == idPais)!.ConvenioIsoTraces,
                    });
                }
            });
        } else {
            this.buscadorOperadorService.getPaisesOperatorsUE().subscribe(res => {
                this.listPais = res;

                if (idPais) {
                    if (idPais != EnumIdsTcPais.ID_ESPANA) {
                        this.form.patchValue({
                            IdPais: this.listPais.find(x => x.Id == idPais)!.ConvenioIsoTraces,
                        });
                    }
                }
            });
        }
    }

    includeEspania(isTransito: boolean, isTraslado: boolean, IdPaisTraslado: number | null, isImpLugarDestino: boolean): boolean {
        if (isTransito || (isTraslado && IdPaisTraslado == EnumIdsTcPais.ID_ESPANA) || isImpLugarDestino) {
            return true;
        }

        return false;
    }

    Emit(importador: TImportadorViewModel): void {
        if (importador.RefTraces) {
            this.display = false;
            importador.IdPaisImportador = this.listPais.find(x => x.ConvenioIsoTraces == this.form.value.IdPais)!.Id;
            if (this.isImpLugarDestino) {
                this.selectedImpLugarDestino.emit(importador);
            } else {
                this.selected.emit(importador);
            }
        } else {
            this.notificacionService.addErrorMessage('Debe seleccionar un Operador con Referencia TRACES.');
        }
    }

    onRowDblClick(event: any, importador: TImportadorViewModel): void {
        this.Emit(importador);
    }

    onSelect(selection: TImportadorViewModel): void {
        this.selectedTImportador = selection;
    }

    acceptDialog(): void {
        this.display = false;

        this.Emit(this.selectedTImportador!);
    }

    cancelDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog): void {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    noAccepted(): boolean {
        return !this.form.valid || !this.selectedTImportador;
    }
}
